const MAINTELLA_MEDIA_PREFIX = 'maintella-media://';

export function mediaLibraryUrlFor(id) {
  if (!id) return '';
  return `${MAINTELLA_MEDIA_PREFIX}${id}`;
}

export function mediaIdFromLibraryUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed.startsWith(MAINTELLA_MEDIA_PREFIX)) return null;
  const id = Number.parseInt(trimmed.slice(MAINTELLA_MEDIA_PREFIX.length), 10);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function isMaintellaMediaUrl(url) {
  return mediaIdFromLibraryUrl(url) != null;
}
